import { addressFrag } from '../../../service/types/common.types';
import { employmentFrag, userRoleGridItemFrag } from '../../../../../services/types/user.types';
import { ruleGridItemFrag } from '../../../../../services/types/acl.types';

export const userGridItemFrag = `
    address {
        ${addressFrag}
    }
    email
    id
    mobile
    name
    phone
    surname
    titleAfterName
    titleBeforeName
    sex
    doctor
    icpOfDoctor
    fax
    personalEmail
    employeeCode
    birthDate
    educationCode
    fieldOfStudy
    image
    employments {
        ${employmentFrag}
    }
    role {
        ${userRoleGridItemFrag}
    }
    active
    organizations {
        id
    }
    groups {
        id
        name
        isPrivate
        rules {
            ${ruleGridItemFrag}
        }
    }
    userLinks {
        id
        userId
        linkId
        linkType
    }
`;
